<template>
  <div class="protocol">
    <header>
      <div class="header">
        <van-icon name="arrow-left" class="i" @click="go" />
        <span>用户协议</span>
      </div>
    </header>
    <h3>田野用户服务协议</h3>
    <div class="content">
      <p>一、 定义</p>
      <p>1.1 田野商城：指名称为田野商城的手机客户端、微信公众号、小程序等，以及未来技术发展出现的新的软件载体，也称“田野”。</p>
      <p>1.2 田野商城服务：田野商城基于互联网，向您提供的各项服务。</p>
      <p>1.3 田野用户：指成功完成田野商城用户注册流程并使用田野商城服务的主体。</p>
      <p>1.4 田野商城规则：包括在所有田野商城内已经发布及未来发布的全部规则、实施细则、产品说明、公告等。</p>
      <p>二、 协议范围</p>
      <p>2.1 签约主体</p>
      <p>本协议由您与田野共同缔结，本协议对您与田野均具有合同效力。</p>
      <p>2.2 商城规则</p>
      <p>田野有权变更、升级、开发、维护田野商城相关服务及其功能，除田野另有说明以外，变更后的服务仍适用本协议。田野有权根据需要不时地制定、修改田野商城的用户服务协议和相关制度、规则，如以上与您利益相关的文本发生变更，田野将在田野商城显著位置公开征求意见，采取合理措施确保您能表达意见，修改后文本会在实施前七日予以公示，您应随时关注田野商城的公示内容。各规则的变更等事项一经田野商城公示，即视为田野已完成对您的书面通知。如您对变更后事项有异议的，您应立即暂停或中止在田野商城上进行操作，如您继续操作的，视为已接受变更后的田野商城规则。</p>
      <p>2.3 用户资格</p>
      <p>您确认，在您开始注册程序使用田野商城服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。用户点击同意本协议的，即视为用户确认自己具有享受本站服务、下单购物等相应的权利能力和行为能力，能够独立承担法律责任。</p>
      <p>三、 商品信息</p>
      <p>3.1 除非另有明确的书面说明，田野商城所包含的或以其他方式通过提供给您的信息、内容、产品，均是在您浏览或下单时现状和现有的基础上提供的。田野商城内展示的商品参数、说明、价格、库存等商品信息尽可能真实准确、全面详细，但受互联网技术发展水平等客观因素的限制，网页显示的信息可能会有一定的滞后性或差错，对此情形请您充分理解并予以谅解。如您发现商品信息错误或有疑问的，请在第一时间告知田野客服人员，并终止提交该订单。</p>
      <p>3.2 田野将尽最大努力确保用户所购商品价格与网站公布的价格一致，尽管如此，由于价格设置、文字描述、配图等错误及不可预见的系统故障等情形，可能出现价格误差，从而导致订单因重大误解或显失公平而无法履行的情况。若出现上述情形，建议您直接联系田野协商解决。</p>
      <p>3.3 田野商城上显示的每一款商品的价格都包含法律规定的税金。</p>
      <p>四、商品交易</p>
      <p>4.1 您通过田野商城订购商品，您提交订单客户下单时间截止为16：00，改单时间截止至18：00，超过此时间系统自动关闭接单信息。</p>
      <p>4.2 田野商城上展示的价格以及其他信息供您下单参考。客户根据线上所有产品选出自己的常用商品，会自动建立订单模版，供日常定货使用。您提交订单，且系统显示订单生成的，则下单成功。</p>
      <p>4.3 田野提供的商品有相应的品牌、品名、规格、计量单位和加工规格，请客户下单时准确选择，如有不清楚的方面，由客服人员协助客户明确商品需求指引客户下单。客户的线上下单和指定送货日期，即我们送货当日严格执行的服务内容。故客户下单过程请仔细核对商品名称、数量，系统会严格执行客户的下单指令，一旦信息有误，由客户自行承担订单错误的损失。</p>
      <p>4.4 生鲜类商品尤其是海鲜产品等规格或数量、鲜活度有正常差异和损耗值，在正常差异和损耗范围类，视为双方认同的标准。</p>
      <p>4.5 田野商城承诺提供产品满足国家规定或业界相关产品质量标准，田野商城承诺提供服务符合法律法规，田野商城竭力为用户提供优质服务以保障消费者合法权益。</p>
      <p>4.6 田野依据法律规定有义务记录、保存田野商城上发布的商品和服务信息、交易信息，并确保信息的完整性、保密性、可用性。商品和服务信息、交易信息保存时间自交易完成之日起保存三年；但任何情况下，如非法律要求，除商城已有服务外，田野不负有另行、随时向您提供前述信息的义务。</p>
      <p>五、订单的取消</p>
      <p>5.1 您有权在下列情况下，取消订单：</p>
      <p>在下单后且订单生成前，按照田野商城使用规则及公示规则，自行在田野商城自助取消订单。为免疑虑，订单是否生成以田野商城通知为准，即若用户点击取消订单后田野商城以弹窗等形式反馈该订单已经生成，则用户不可自行取消该订单。</p>
      <p>5.2 田野商城在下列情况下可以与用户协商取消订单：</p>
      <p>（1）网站上显示的商品信息错误或缺货的；</p>
      <p>（2）用户订单信息明显错误；</p>
      <p>（3）田野商城其他规则约定的情形（约定内容与法律法规冲突的除外）；</p>
      <p>5.3 尽管田野商城做出最大的努力，但由于市场变化及各种以合理商业努力难以控制因素的影响，田野无法避免您提交的订单信息中的商品出现缺货情况；如您下单所购买的商品发生缺货，您有权取消订单，田野及平台内商家亦有权在征得您同意的情况下取消订单，若您已经付款，则为您办理退款服务。</p>
      <p>5.4 您在此确认并知晓因您个人原因申请取消订单，针对田野商城已经同意的退货申请，如果货物已发货，则您需要自行承担运费并需要按照田野商城规则提交相应材料。</p>
      <p>六、 配送规则</p>
      <p>6.1 田野商城负责将订购商品在双方确认的配送时间内配送到用户指定的收货地址，我们尽可能调整线路的顺序满足客户要求。如无法调整，需商定专项解决方案或物流付费模式沟通协商，田野商城另有规定的除外。您所购买的商品应仅由您公司指定的联系人接收商品，因您变更联系人或相关配送信息而造成的损失由您自行承担。</p>
      <p>6.2 除田野质量原因或服务失误导致的漏货、缺货由我司配送人员回程途中协助就近补货和换货，若因市场原因无法补货和换货，客户可与配送人员或客服人员沟通协商，在线上配送单上改单冲减扣除。</p>
      <p>6.3 其他客户加补需求，由区域指定供应商提供服务或客户自行安排补货，补货清单和数据由客户在补货端口提交数据作为月底结算付款凭证。客户临时加补的补货的税率因无法预知产品，因此税率以田野提供固定税率为准。客户加补的商品需加收12%的服务费。</p>
      <p>6.4 货物送达，需当面交接，质量异常需当日沟通，经沟通协商后予以退货或就近补货处理。客户需安排安全存放地点，需保鲜的商品做好保鲜措施，因客户存放不当导致的食材变质腐化，公司不承担退换责任。</p>
      <p>6.5 客户如需纸质配送单，请与客服人员或配送人员沟通确认后，由配送员随货物配送当天提供纸质单据，加补数据在第二天配送单上提供或者另行打印单据。</p>
      <p>6.6 客户自行提供生鲜储存的用品用具，当天田野配送商品提供周转的框具和包装用品用具等需当天回收，以利于隔日配送周转使用，如客户需要提供周转筐具，则需要公司盖章签收暂存单，如有损坏或遗失照价赔偿；</p>
      <p>6.7 因如下情况造成订单延迟或无法配送、交货等，田野商城不承担延迟配送、交货的责任：</p>
      <p>（1）您提供的信息错误、地址不详细等原因导致的；</p>
      <p>（2）货物送达后无人签收，导致无法配送或延迟配送的；</p>
      <p>（3）不可抗力因素导致的，例如：自然灾害、突发战争等情况，双方协商配送预案。</p>
      <p>6.8 物流费</p>
      <p>田野平台，6-8月提供冷链车辆配送，其它月份为常温车辆配送时间段。在常温车辆配送时间段内客户如需冷链车辆配送，双方按送货时间和物流区域协商冷链物流费用。</p>
      <p>七．支付方式</p>
      <p>7.1 在线预付方式：您需要在下单成功后规定时间内完成付款，付款成功后订单生效。</p>
      <p>7.2 货到账期付款方式：双方约定对帐日期和结算帐期，您需要严格按照约定的日期对帐开票完成支付工作。月结的付款凭证以客户线上累计订单确认汇总的金额作为结算金额，月结的客户对账日期为次月1-10日，田野对完账后会发送客户结款清单并提供发票，客户需在送货次月30日内付清货款，未及时付款田野有权自动终止合作；</p>
      <p>郑重提示：在线预付和月结方式下，请您按照田野商城的指引的帐号完成在线支付或银行转账。</p>
      <p>八、关于田野商城上内容的获取与更新</p>
      <p>8.1 除非法律允许或田野书面许可，您使用本软件过程中不得从事下列行为：</p>
      <p>（1）删除本软件及其副本上关于著作权的信息；</p>
      <p>（2）对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；</p>
      <p>（3）对田野商城拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
      <p>（4）对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经田野商城授权的第三方工具/服务接入本软件和相关系统；</p>
      <p>（5）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</p>
      <p>（6）通过非田野商城开发、授权的第三方软件、插件、外挂、系统，登录或使用田野商城软件及服务，或制作、发布、传播上述工具；</p>
      <p>（7）自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰。</p>
      <p>8.2 作弊、扰乱交易秩序的情况</p>
      <p>（1）若您参加田野商城包括并不限于促销优惠、秒杀、抽奖等的优惠活动，除活动规则另有规定外，每次活动中，每个用户只限参加一次活动，每个用户只能中奖一次。同一手机、同一联系方式、同一IP地址、同一田野商城账户、同一收货地址、同一终端设备号或其他可以合理显示为同一用户的情形，均视为同一用户。如发现用户通过包括但不限于侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、恶意套现、刷信誉、批量注册、用机器注册账户、用机器模拟客户端等不正当手段参加活动而有碍其他用户公平参加活动或有违反活动目的之行为，田野有权取消其获奖资格或其因参加活动所获赠品或权益。如该作弊行为给田野造成损失的，田野保留追究赔偿的权利。</p>
      <p>
        （2）若用户有恶意进行注册，反复下单退货，或侵害田野商城实际经营交易的情况，田野商城有权中止或终止服务、封停账号并追究责任。
        九、用户信息的保护及授权
      </p>
      <p>9.1 您再次理解并同意，在田野商城进行注册、浏览、下单购物、参加活动等行为时，涉及您的真实姓名/名称、通信地址、联系电话、电子邮箱、订单详情等信息的，田野商城将从完成交易、提供配送、售后及客户服务、开展活动、完成良好的用户体验等多种角度予以收集，并将对其中涉及个人隐私信息予以严格保密。</p>
      <p>9.2 田野商城保证不对外公开或向任何第三方提供您的个人信息，但是存在下列情形之一的除外：</p>
      <p>（1）事先获得您的明确授权；</p>
      <p>（2）系为履行您的订单或保护您的合法权利所必须；</p>
      <p>（3）系为履行法律义务；</p>
      <p>（4）本注册协议或其他条款另有约定。</p>
      <p>9.3 您充分理解并同意：</p>
      <p>（1）接收通过邮件、短信、电话等形式，向在田野商城注册、购物的用户、收货人发送的订单信息、促销活动等内容；</p>
      <p>（2）为配合行政监管机关、司法机关执行工作，在法律规定范围内田野有权向上述行政、司法机关提供您在使用田野商城时所储存的相关信息，包括但不限于您的注册信息等，或使用相关信息进行证据保全，包括但不限于公证、见证等；</p>
      <p>（3）田野依法保障您在安装或使用过程中的知情权和选择权，在您使用本软件服务过程中，涉及您设备自带功能的服务会提前征得您同意，您一经确认，田野有权开启包括但不限于收集地理位置、读取通讯录、使用摄像头、启用录音等提供服务必要的辅助功能。</p>
      <p>（4）田野有权根据实际情况，在法律规定范围内自行决定单个用户在本软件及服务中数据的最长储存期限以及用户日志的储存期限，并在服务器上为其分配数据最大存储空间等。</p>
      <p>十、所有权和知识产权条款</p>
      <p>10.1 田野商城所有的产品、技术与所有程序均属于田野商城所有者的知识产权。“田野”、以及相关图形、标识等为田野商城所有者的注册商标。未经田野商城所有者许可，任何人不得擅自使用田野商城所有者的任何知识产权，包括但不限于以非法的方式复制、传播、展示、镜像、上载、下载，或对田野商城网站资料作全部和局部复制、转载、引用和链接等。否则，田野商城所有者将依法追究法律责任。</p>
      <p>10.2 除明显归属于合作伙伴、第三方所有的信息资料外，田野商城所有者拥有田野商城及其关联公司网站、田野商城移动终端内所有内容，包括但不限于文字、图片、图形、表格、动画、程序、软件等单独或组合的版权。任何被授权的浏览、复制、打印和传播属于本网站内的内容必须符合以下条件：</p>
      <p>（1)所有的资料和图象均以获得信息为目的；</p>
      <p>（2)所有的资料和图象均不得用于商业目的；</p>
      <p>（3)所有的资料、图象及其任何部分都必须包括此声明。</p>
      <p>10.3 用户一旦接受本协议，即表明该用户同意并主动将其在任何时间段在本站发表的任何形式的信息内容的财产性权利等任何可转让的权利，如著作权财产权等全部独家且不可撤销的转让给田野商城经营者所有。</p>
      <p>10.4 田野商城所有者是田野商城的制作者，拥有田野商城内容及资源的著作权等合法权利，受国家法律保护，有权对本协议及田野商城的内容进行修改，并在田野商城公示，无需另行通知用户。在法律允许的最大限度范围内，田野商城所有者对本协议及田野商城内容拥有解释权。</p>
      <p>10.5 除法律另有强制性规定外，未经田野商城所有者明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或其他方式使用田野商城的信息内容。</p>
      <p>10.6 若田野商城上的信息违反了国家法律法规，或侵犯了您或第三方的合法权益，请与田野商城所有者联系，田野商城所有者将对您提供的信息进行核实，并对经核实的情况采取措施。具体流程和联系方式请参考田野商城公示的《田野权利通知》。</p>
      <p>十一、 违约条款</p>
      <p>11.1 违约认定</p>
      <p>发生如下情形之一的，视为您违约：</p>
      <p>（1) 使用田野商城服务时违反有关法律法规规定的；</p>
      <p>（2) 违反本协议或本协议补充协议约定的。</p>
      <p>为适应电子商务发展和满足海量用户对高效优质服务的需求，您理解并同意，田野可在田野商城规则中约定违约认定的程序和标准。如：田野可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。</p>
      <p>11.2 若您被认定违约的，田野有权中止或终止向您提供服务。</p>
      <p>11.3 如果田野发现或收到他人举报投诉您违反本协议约定的，田野有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁直至注销的处罚，并公告处理结果。</p>
      <p>11.4 田野有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。</p>
      <p>11.5 您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；田野因此遭受损失的，您也应当一并赔偿。</p>
      <p>11.6 除非另有明确的书面说明,田野不对本软件的运营及其包含在本软件上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。</p>
      <p>十二、争议解决</p>
      <p>本协议的订立、执行和解释及争议的解决均应适用中华人民共和国的法律。如就本协议内容或其执行发生任何争议，则双方应首先协商解决；协商不成的，任何一方均应向北京市朝阳区人民法院提起诉讼。</p>
      <p>十三、其他</p>
      <p>13.1 不论在何种情况下，田野对由于信息网络设备维护、信息网络连接故障、电脑、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。</p>
      <p>13.2 为给您提供更好的服务以及随着田野商城业务的发展，本服务协议也会随之更新。我们会通过在田野商城移动端上发出更新版本并在生效前通过公告或以其他适当方式提醒您相关内容的更新，也请您访问田野商城以便及时了解最新的服务协议。</p>
      <p>
        您知悉并确认，如您不同意更新后的内容，应立即停止使用本服务；如您继续使用田野商城服务，即视为您知悉变动内容并同意接受。
        13.3 本协议及田野商城公示的《田野隐私政策》、《田野权利通知》及平台公布的协议、规则、声明等构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。
      </p>
      <p>13.4 如本协议中的任何条款无论因何种原因被视为完全或部分无效或不具有执行力，该条应视为可分的，且不影响本协议的任何其余条款的有效性、约束力及可执行性。</p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    go() {
      window.history.back();
    }
  }
};
</script>

<style scoped>
.protocol {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
  padding: 5%;
  background: rgba(242, 242, 242, 1);
  padding-top: 40px;
}
h3 {
  text-align: center;
}
header {
  position: fixed;
  z-index: 999;
  left: 0;
  width: 100%;
  line-height: 40px;
  font-weight: 400;
  padding-left: 5%;
  top: 0;
  background: rgba(237, 237, 237, 1);
}
.header {
  position: relative;
  padding-left: 20px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  width: 70px;
}
.i {
  position: absolute;
  left: 0;
  top: 13px;
}
.content {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
  font-weight: 400;
}
p {
  font-weight: 300;
  font-size: 14px;
}
</style>